import { getCachedResponse, setCachedResponse, setCachedUrl } from "../cache";
import request from "./request";

let requestPromise = null;

const promiseChainApiCall = (url) => {
  if (requestPromise === null) {
    requestPromise = request(url).then((response) => {
      setCachedUrl(url);
      setCachedResponse(response);

      requestPromise = null;

      return getCachedResponse();
    });
  }

  return requestPromise;
};

export default promiseChainApiCall;
